import * as React from 'react';
import './plansPane2.module.scss';
import { inject, observer } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { observable } from 'mobx';
import { V3Routes } from '../../../routes';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { BackButtonHeader } from './BackButtonHeader';
import { PlanPaneState2 } from './states/PlanPaneState2';
import { findNextSummary, filterVisibleMembershipSummaries } from './plans/MembershipSummaryListView';
import { Confirmation } from '../../molecules/modals/Confirmation';
import { Pane, PaneHeader } from '../../molecules/mypage/page';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { WithdrawalLabel } from './withdrawal/WithdrawalLabel';
import { WithdrawalState } from '../../../../commonv3/states/WithdrawalsState';
import { MembershipSummary } from '../../../types/membershipSummaries';
import { Link } from 'react-router-dom';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { SubscriptionSummaryListView } from './plans/SubscriptionSummaryListView';

type Props = {
    homeState: HomePageState;
};

type WithdrawalLinkProps = {
    hasSubscription: boolean;
    withdrawal: WithdrawalState;
    summaries: MembershipSummary[];
    hasFailedTransactions: boolean;
};

function willChangePlan(summaries): boolean {
    return filterVisibleMembershipSummaries(summaries).some((s) => findNextSummary(s, summaries));
}

export class WithdrawalLink extends React.Component<WithdrawalLinkProps> {
    render() {
        const { hasSubscription, withdrawal, summaries, hasFailedTransactions } = this.props;
        if (!hasSubscription) {
            return null;
        }
        if (withdrawal.isWithdrawalSet) {
            return null;
        }
        //TODO: 現状プラン変更しているユーザーへの退会処理は対応していないがいつか対応したい
        if (willChangePlan(summaries)) {
            return null;
        }
        return (
            <div styleName="unsubscribe" id="withdrawal-link">
                <div styleName="unsubscribe-text">退会はこちらから手続きにお進みください</div>
                {hasFailedTransactions && (
                    <div styleName="mask">
                        一部のお支払いが完了していないため退会手続きに進むことができません。<br />
                        マイページの<Link to={V3Routes.payments()}>『支払い情報 / 変更』</Link>から確認をお願いします。
                    </div>
                )}
                <Button
                    type="underline"
                    size="s"
                    styleName="withdrawal-button"
                    id="withdrawal-button"
                    disabled={hasFailedTransactions}
                    onClick={() => GlobalStatesV3.routing.push(V3Routes.withdrawalApply())}
                >
                    退会手続きに進む
                </Button>
            </div>
        );
    }
}

@inject('homeState')
@observer
export class PlansPane2 extends React.Component<Props> {
    @observable pageState = new PlanPaneState2();

    componentDidMount(): void {
        this.pageState.init();
    }

    render() {
        const {
            cancelUpdateDialog,
            requestCancelUpdate,
            cancelUpdate,
            submitState,
            hasSubscription,
            cancelSuspension,
            loading,
            subscriptionSummaries: subscriptionSummaryResources,
        } = this.pageState;
        const currentUser = GlobalStatesV3.currentUser;
        const { withdrawal } = currentUser;
        const subscriptionSummaries = subscriptionSummaryResources.getOrElse([]);
        if (loading) {
            return <LoaderRow />;
        }
        return (
            <Pane activeMenu={'plans'}>
                {GlobalStatesV3.viewport.isMobile && <BackButtonHeader to={V3Routes.myPage()} />}
                <PaneHeader>プランの確認 / 変更</PaneHeader>
                {withdrawal.isWithdrawalSet && hasSubscription && <WithdrawalLabel withdrawal={withdrawal} />}
                <div styleName="list-wrapper">
                    <SubscriptionSummaryListView
                        summaries={subscriptionSummaries}
                        isWithdrawalSet={withdrawal.isWithdrawalSet}
                        onUpdateRequest={(itemId) => GlobalStatesV3.routing.push(V3Routes.planUpdate(itemId))}
                        onUpdateCancelRequest={requestCancelUpdate}
                        onCancelSuspensionRequest={cancelSuspension}
                    />
                </div>
                <WithdrawalLink
                    hasSubscription={hasSubscription}
                    withdrawal={withdrawal}
                    summaries={this.pageState.membershipSummaries}
                    hasFailedTransactions={currentUser.hasFailedTransactions}
                />
                <Confirmation
                    headerMessage="プラン変更のキャンセル"
                    message="プラン変更予約を取り消します。よろしいですか？"
                    confirmationText="キャンセルする"
                    open={cancelUpdateDialog.isOpen}
                    onAbort={cancelUpdateDialog.close}
                    onConfirmation={cancelUpdate}
                    loading={submitState.submitting}
                />
            </Pane>
        );
    }
}
